export default __webpack_public_path__ + "static/cafe-2ae9af0810c3e60f64e502496cf5b1f2.jpg";